import { render, staticRenderFns } from "./HeaderLangToggle.vue?vue&type=template&id=422157f8&scoped=true&"
import script from "./HeaderLangToggle.vue?vue&type=script&lang=js&"
export * from "./HeaderLangToggle.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLangToggle.vue?vue&type=style&index=0&id=422157f8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422157f8",
  null
  
)

export default component.exports